import type { VerticalAudience } from '../content/insuranceVerticals'
import { Reveal } from './Reveal'

/** "Who it's for" band: a heading and one card per kind of customer the trade works for. */
export function VerticalAudiences({
  heading,
  audiences,
}: {
  heading: string
  audiences: VerticalAudience[]
}) {
  return (
    <section className="bg-white px-5.5 py-24">
      <div className="mx-auto flex max-w-(--maxw) flex-col gap-10">
        <Reveal className="flex max-w-180 flex-col gap-3">
          <span className="eyebrow self-start">Who it’s for</span>
          <h2 className="h2 text-balance">{heading}</h2>
        </Reveal>
        <Reveal delay={120} className="grid grid-cols-2 gap-4 max-md:grid-cols-1">
          {audiences.map((audience) => (
            <div
              key={audience.label}
              className="border-ink-100 flex flex-col gap-3 rounded-sm border p-8 max-md:p-6"
            >
              <span className="text-ink-500 font-mono text-xs tracking-[0.14em] uppercase">
                {audience.label}
              </span>
              <span className="text-ink text-2xl font-bold tracking-[-0.01em] text-pretty">
                {audience.title}
              </span>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  )
}
